import styled from 'styled-components';
import { IStyle } from './types';

export const Overlay = styled.div<{ isOpen: boolean }>`
  display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  align-items: center;
  justify-content: center;
  z-index: 100000;
`;

export const ModalContent = styled.div<IStyle>`
  background: #fff;
  padding: 20px;
  border-radius: 10px;
  max-width: 700px;
  width: 100%;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: ${({ maxHeight }) => (maxHeight ? maxHeight : 500)}px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0;
  margin: 0;
  z-index: 999;
  background: #fff;
`;
export const Button = styled.button`
  display: flex;
  gap: 5px;
  align-items: center;
  border: none;
  outline: none;
  background: none;
  margin: 0;
  padding: 0;
  cursor: pointer;
`;
export const TitleGoBack = styled.p`
  color: #226a43;
  font-size: 16px;
  font-weight: 500;
  margin: 0;
  padding: 0;
`;

export const WrapperTitle = styled.div`
  display: flex;
  gap: 10px;
`;

export const Title = styled.p`
  color: #1b1b1b;
  font-size: 18px;
  font-weight: 500;
  margin: 0;
  padding: 0;
`;
export const WrapperChildren = styled.div`
  flex: 1;
  display: flex;
  max-width: 660px;
  width: 100%;
`;
